import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular/main';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Component({
  selector: 'clickable-cell',
  template: `
  <row-checkbox
    (onChange)="onChange($event)"
    [isCheckboxSelected]="isCheckboxSelected">
  </row-checkbox>
  `,
  styles: []
})
export class RowCheckBoxParentComponent implements ICellRendererAngularComp {
  private params: any;
  public cell: any;
  private position: any;

  isCheckboxSelected = new BehaviorSubject<boolean>(false);

  agInit(params: any): void {
    this.params = params;
    this.position = this.params.node.data.data.position;
    this.isCheckboxSelected.next(this.params.value);
    this.cell = {
      rowNode: params.node,
      colName: params.colDef.headerName,
      colDef: this.params.colDef,
      value: this.params.value
    };
  }

  /**
   *  This is the emitter event from the Child Checkbox Component
   * @param isChecked
     */
  public onChange(isChecked: any) {
    this.params.context.componentParent
      .onParentComponentCall(this.params, isChecked);
    //Listener to handle the Cell and Row. Save to Model;
    //this.params.node.setDataValue(this.params.colDef, (this.checked ? "On" : "Off"));
  }

  refresh(data): boolean {
    this.isCheckboxSelected.next(data.value);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/grids/row-checkbox-parent.component.ts